import parseUrlQueryString from 'services/parseUrlQueryString/parseUrlQueryString';
import { SubscriptionReferralUrlParams } from '../../types';
import { mergeSubscriptionKeysWithLid } from '../marketingCloudSubscription';

export const parsePreferencesQuery = (query: string): SubscriptionReferralUrlParams => {
  const { hid, key, source, lid, subscribeKeys, jobId } = parseUrlQueryString(query);
  const unsubscribeKeys: string | undefined = mergeSubscriptionKeysWithLid(
    source as string,
    key as string,
    Number(lid),
  );
  const decodeSubscribeKeys = (subscribeKeys as string)?.replace('+', '').replace('%20', '');
  return {
    hid: hid as string,
    source: source as string,
    unsubscribeKeys,
    subscribeKeys: decodeSubscribeKeys,
    jobId: jobId as string,
  };
};
